import React from "react";
import { Outlet } from "react-router-dom";
import AppLayout from "../components/AppLayout";
const Root = () => {
  return (
    <div className="root-page">
      <AppLayout>
        <Outlet />
      </AppLayout>
    </div>
  );
};

export default Root;
